import React from "react";
import { Button } from "@mui/material";
import { useFormContext } from "react-hook-form";

export default function SameQuestionButton() {
	const { getValues } = useFormContext();

	const onCreateSameQuestion = () => {
		const question = getValues();
		question.title = undefined;
		question.number = undefined;
		question.id = undefined;
		question.solution = undefined;
		question.problem = undefined;
		question.answer_config = null;
		question.correct_answer = null;
		question.hint = undefined;
		localStorage.setItem("same_question_md", JSON.stringify(question));
		window.open("/questions/create");
	};

	return (
		<Button variant={"text"} onClick={onCreateSameQuestion}>
			Создать похожую задачу
		</Button>
	);
}
